class TesterHomeController {
    constructor(
    // angular services
    $window, $browser, $timeout, $routeParams, $location, toastr, $uibModal, ngProgressFactory, Upload, moment, UserDetailsApi, UtpUserTestSuitesServiceApi, UtpTestRunnerServiceApi, ResetService, ModalService, StateService, SettingsService, StoredItemsService, TesterSimSuitesServiceApi, TraceHubExService, multiTestNotificationService, ProjectTestingServiceApi) {
        this.$onInit = () => {
            this.connectionId = '0';
            this.simError = false;
            this.traceProgress = this.ngProgressFactory.createInstance();
            this.state = {
                debug: false, // Use this to inspect the state
                selectedTester: null,
                selectedSim: null,
                selectedSuite: null,
                selectedTest: null,
                runDisabled: false,
                showError: false,
                errorMsg: null,
                uploadProgress: -1,
                showExpiryIcons: true,
                maxUploadMb: 0,
                overTheShoulder: false,
                userCardsPerSim: false,
                DateFormats: null,
                visibleExpirys: '',
                userDetails: null,
                isSupporting: false,
                simulatorsLoading: true,
                projectTestingEnabled: false,
                multiTestEnabled: false,
                multiTestSelectedCases: [],
                multiTestSentCases: [],
                multiTestIsRunning: false,
                multiTestIsLoading: false,
                multiTestTestSuiteEnabled: true
            };
            this.data = {
                TestSuites: [],
                Sims: [],
                TestCaseResults: [],
                UserSimProjects: []
            };
            // Initialize values before TestRun
            this.multiTestProgress = {
                TestRunId: 0,
                TotalTestCount: 0,
                PassedTestCount: 0,
                FailedTestCount: 0,
                InconclusiveTestCount: 0
            };
            this.SettingsService.getSettings().then((response) => {
                const appSettings = response.data;
                this.TraceHubExService.connectWithSpecificTransport('tester-view', appSettings.SignalRTransport);
                // Set the connectionId on vm.state.connectionId
                this.TraceHubExService.on('tester-view', 'onInit', (connId) => {
                    this.connectionId = connId;
                });
                this.TraceHubExService.on('tester-view', 'onTestRunTestCaseStatusChange', (e) => {
                    if (e.TestRunId === this.multiTestProgress.TestRunId && e.TesterId === this.state.selectedTester.Id) {
                        if (e.NewStatus.toString().toUpperCase() === 'RUNNING') {
                            this.updateTestCaseStatus(e.TestCaseId, e.NewStatus.toString());
                        }
                        if (e.NewStatus.toString().toUpperCase() === 'COMPLETE') {
                            let oldObject = _.find(this.state.multiTestSentCases, { Id: e.TestCaseId });
                            oldObject.Status = (VerdictType[e.Verdict]);
                            // Setting Progress update parameters received
                            this.multiTestProgress.TotalTestCount = e.TotalTestCount;
                            this.multiTestProgress.PassedTestCount = e.PassedTestCount;
                            this.multiTestProgress.FailedTestCount = e.FailedTestCount;
                            this.multiTestProgress.InconclusiveTestCount = e.InconclusiveTestCount;
                        }
                    }
                });
                this.TraceHubExService.on('tester-view', 'onTestRunStatusChange', (e) => {
                    if (e.TestRunId === this.multiTestProgress.TestRunId && e.TesterId === this.state.selectedTester.Id) {
                        let newStatus = e.NewStatus.toString().toUpperCase();
                        if (newStatus === 'COMPLETE' || newStatus === 'CANCELLED') {
                            this.state.multiTestIsRunning = false;
                        }
                    }
                });
                this.state.maxUploadMb = response.data.MaxUploadMb;
                this.state.DateFormats = {
                    DateTimeFormat: appSettings.DateTimeFormat,
                    DateFormat: appSettings.DateFormat,
                    TimeFormat: appSettings.TimeFormat
                };
                this.state.showExpiryIcons = appSettings.TestSuiteExpirationVisibleClasses !== '';
                this.state.visibleExpirys = appSettings.TestSuiteExpirationVisibleClasses;
                this.state.userCardsPerSim = appSettings.UserCardsModule && appSettings.TesterCanEditUserCards;
                this.state.projectTestingEnabled = appSettings.ProjectTestingEnabled;
                this.state.multiTestEnabled = appSettings.MultiTestModule;
                this.UserDetailsApi.get().then((response) => {
                    let connectedUser = response.data;
                    // Get our user details
                    this.state.userDetails = connectedUser; // setup our user details
                    // Determine if we are we in a supporting role
                    this.state.isSupporting =
                        connectedUser.IsSupport || connectedUser.IsProjectTester;
                    if (this.routeParams.testerId) {
                        // We are here as Support for tester
                        const testerId = this.routeParams.testerId;
                        this.UserTestSuiteService.getTester(testerId).then((response) => {
                            const tester = response.data;
                            this.state.selectedTester = tester;
                            this.StoredItemsService.storeTester(tester);
                            this.loadUserModel(tester.Id);
                        });
                        this.state.overTheShoulder = true;
                    }
                    else {
                        // We are here as tester
                        const tester = {
                            Id: connectedUser.Id,
                            Name: connectedUser.Description
                        };
                        this.state.selectedTester = tester;
                        this.StoredItemsService.storeTester(tester);
                        this.state.overTheShoulder = false;
                        this.loadUserModel(tester.Id);
                    }
                }, () => {
                    this.toastr.error('Please make sure that you are logged in to OTS UTP!');
                    this.window.location.href =
                        this.browser.baseHref() + 'account/login';
                    return;
                });
            });
        };
        this.$onDestroy = () => {
            this.TraceHubExService.stop('tester-view');
        };
        this.updateTestCaseStatus = (tcId, newStatus) => {
            let tc = _.find(this.state.multiTestSentCases, { Id: tcId });
            if (tc !== null) {
                tc.Status = newStatus;
            }
        };
        this.getPercentage = (count) => {
            return ((count / this.multiTestProgress.TotalTestCount) * 100);
        };
        this.selectTest = (test) => {
            this.state.selectedTest.Id = test.Id;
        };
        this.generatePopUp = (date) => {
            if (date === undefined || date === null) {
                return 'LIVE - No Expiry Date';
            }
            const expiryMoment = this.moment(date);
            const expiryDate = expiryMoment.format(this.state.DateFormats.DateFormat);
            const today = this.moment();
            let popupText = 'Will expire on ';
            if (today.isAfter(expiryMoment)) {
                popupText = 'Expired on ';
            }
            else if (expiryMoment.diff(today, 'days') < 14) {
                popupText = 'Expiring on ';
            }
            return popupText + expiryDate;
        };
        this.generateTestSuitePopups = () => {
            _.forEach(this.data.TestSuites, (suite) => {
                suite.popupText = this.generatePopUp(suite.ExpiryDate);
                suite.expired = this.moment().isAfter(this.moment(suite.ExpiryDate));
            });
        };
        this.back = () => {
            // TODO: We need to handle the TeamSupport user who goes back to
            // his landing page not UserTestSuites
            // NOTE: This link is for the support user only
            if (this.state.userDetails.IsProjectTester) {
                this.$location.path('/');
                return;
            }
            this.$location.path('/UserTestSuites');
        };
        this.getItemById = (collection, id) => {
            const ret = _.find(collection, ['Id', id]);
            return ret;
        };
        this.loadUserModel = (testerId) => {
            // Get our stored tester (required), sim (poss -1), and suite (poss -1)
            this.StoredItemsService.load().then((response) => {
                let storedItems = response;
                const simId = storedItems.sim.Id;
                this.getUserModel(testerId, simId, null);
            });
        };
        this.getUserModel = (testerId, simId, suiteId) => {
            this.traceProgress.start();
            let responseMask = 0;
            let req = {
                TesterId: testerId,
                SimId: simId,
                SuiteId: suiteId
            };
            this.TesterSimSuitesServiceApi.getUserModelWithSimStatus(req).then((response) => {
                try {
                    responseMask = (responseMask | 1);
                    if (responseMask === 7) {
                        this.traceProgress.complete();
                    }
                    const data = response.data;
                    this.data.Sims = data.SimsWithStatus;
                    let counter = 0;
                    let simIndex = 0;
                    this.data.Sims.forEach((Sim) => {
                        if (Sim.CategoryDesc !== 'Clearing') {
                            counter++;
                            simIndex = this.data.Sims.indexOf(Sim);
                        }
                    });
                    if (this.state.projectTestingEnabled && counter === 1) {
                        if (this.data.Sims[simIndex].RequiresProjectTesting) {
                            this.openProjectTesting(this.data.Sims[simIndex]);
                            this.traceProgress.complete();
                            return;
                        }
                    }
                    this.ProjectTestingServiceApi.getAllUserProjects(testerId).then((response) => {
                        if (response.data)
                            this.data.UserSimProjects = response.data;
                    });
                    this.state.simulatorsLoading = false;
                    this.data.TestSuites = data.TestSuites;
                    this.data.TestCaseResults = data.TestCaseResults;
                    // At this point we know from the response what should be selected
                    const sim = this.getItemById(data.SimsWithStatus, data.SelectedSimId);
                    const suite = this.getItemById(data.TestSuites, data.SelectedSuiteId);
                    this.state.multiTestTestSuiteEnabled = suite ? suite.SupportsMultitest : true;
                    this.state.selectedSim = sim;
                    this.StoredItemsService.storeSim({ Id: sim.Id, Name: sim.Name });
                    this.state.selectedSuite = suite;
                    // TODO: Figure out what the edge case is here
                    if (this.state.selectedSuite === null) {
                        this.traceProgress.complete();
                        return;
                    }
                    if (data.TestCaseResults.length > 0) {
                        this.StoredItemsService.load().then((storedItems) => {
                            // TODO: handle case where there are no tests
                            const test = storedItems.test.Id === -1
                                ? data.TestCaseResults[0]
                                : storedItems.test;
                            this.state.selectedTest = {
                                Id: test.Id,
                                Name: test.Name
                            };
                            this.StoredItemsService.storeTest(test);
                        });
                    }
                    this.generateTestSuitePopups();
                    // TODO: Move the api call into the selectSuite method and call it from here
                    // NOTE: If we are a tester then we instruct the UtpTestRunner api to spin up the selected sim
                    if (!this.state.multiTestIsRunning && this.state.selectedSuite) {
                        this.state.runDisabled = true;
                        const simId = this.state.selectedSim.Id;
                        const suiteId = this.state.selectedSuite.Id;
                        const suiteName = this.state.selectedSuite.Name;
                        const testerId = this.state.userDetails.IsTester
                            ? this.state.userDetails.Id
                            : this.state.selectedTester.Id;
                        let req = {
                            SimId: simId,
                            SuiteId: suiteId,
                            SuiteName: suiteName,
                            UserId: testerId,
                            TestId: 0
                        };
                        this.UtpTestRunnerServiceApi.selectSuite(req).then((response) => {
                            // TODO: Find out if the error is handled by ApiErrorService
                            // NOTE: We need to be properly configured on the server side or we get an error
                            if (angular.isUndefined(response)) {
                                this.simError = true;
                            }
                            else if (!response.data.Result.success) {
                                this.simError = true;
                            }
                            else {
                                this.simError = false;
                                this.state.runDisabled = false;
                            }
                            responseMask = (responseMask | 2);
                            if (responseMask === 7) {
                                this.traceProgress.complete();
                            }
                        });
                    }
                    else {
                        responseMask = (responseMask | 2);
                        if (responseMask === 7) {
                            this.traceProgress.complete();
                        }
                    }
                    /* Check and Load Multi Test Run State */
                    if (this.state.selectedSuite != null) {
                        this.UtpTestRunnerServiceApi.getRunningMultiTests(this.state.selectedTester.Id, this.state.selectedSim.Id, this.state.selectedSuite.Id)
                            .then((response) => {
                            responseMask = (responseMask | 4);
                            this.RestoreMultiTestRun(response.data);
                            if (responseMask === 7) {
                                this.traceProgress.complete();
                            }
                        });
                    }
                    else {
                        responseMask = (responseMask | 4);
                        if (responseMask === 7) {
                            this.traceProgress.complete();
                        }
                    }
                }
                catch (ex) {
                    this.toastr.warning('Error getting test information');
                    this.traceProgress.complete();
                }
                /* Check and Load Multi Test Run State ends here*/
            });
        };
        this.RestoreMultiTestRun = (runningTestCases) => {
            this.state.multiTestSelectedCases = [];
            runningTestCases.forEach(r => {
                let sTC = _.find(this.data.TestCaseResults, t => t.Id === r.TestCaseId);
                this.state.multiTestSelectedCases.push({
                    Id: r.TestCaseId,
                    Name: sTC.Name,
                    Status: TestRunTestCaseStatus[r.Status],
                    ClearingStatus: sTC.ClearingStatus,
                    TerminalStatus: sTC.TerminalStatus,
                    TruncatedName: sTC.TruncatedName,
                    SupportsMultitest: sTC.SupportsMultitest,
                    WaiverStatus: sTC.WaiverStatus
                });
            });
            this.state.multiTestSentCases = this.state.multiTestSelectedCases;
            if (this.state.multiTestSelectedCases.length > 0) {
                this.state.multiTestIsRunning = !this.state.multiTestIsRunning;
                /* TestRunTestCases are running under this TestRunId */
                this.multiTestProgress.TestRunId = runningTestCases[0].TestRunId;
                /* Emit global event */
                let e = {
                    simId: this.state.selectedSim.Id,
                    testerId: this.state.selectedTester.Id,
                    suiteId: this.state.selectedSuite.Id,
                    multiTestIsRunning: this.state.multiTestIsRunning
                };
                this.multiTestNotificationService.changeAllOnMultiTestRun(e);
                this.toastr.info('Selected Test Cases are currently running');
            }
        };
        this.resolveMultiRunTestCaseIcon = (testCase) => {
            if (_.some(this.state.multiTestSentCases, x => x.Id === testCase.Id)) {
                return _.find(this.state.multiTestSentCases, x => x.Id === testCase.Id).Status.toUpperCase();
            }
            return 'NOT_RUNNING';
        };
        this.selectSim = (sim) => {
            if (this.state.selectedSim.Id === sim.Id) {
                return;
            }
            this.state.selectedSim = sim;
            const userId = this.state.selectedTester.Id;
            const simId = sim.Id;
            this.getUserModel(userId, simId, null);
            this.StoredItemsService.storeSim(sim);
        };
        this.selectSuite = (suite) => {
            this.state.selectedSuite = suite;
            const userId = this.state.selectedTester.Id;
            const simId = this.state.selectedSim.Id;
            const suiteId = suite.Id;
            const fullSuite = this.getItemById(this.data.TestSuites, suite.Id);
            this.state.multiTestTestSuiteEnabled = fullSuite ? fullSuite.SupportsMultitest : true;
            this.getUserModel(userId, simId, suiteId);
            this.StoredItemsService.storeSim(suite);
            // TODO: Call api select suite
        };
        this.updateTestResults = () => {
            this.selectSuite(this.state.selectedSuite);
        };
        this.gotoTraceSummary = () => {
            // Tester sees his own traces
            // Support and TeamSupport see the selectedTest's traces
            const tester = this.state.userDetails.IsTester
                ? { Id: this.state.userDetails.Id, Name: this.state.userDetails.UserName }
                : this.state.selectedTester;
            this.StateService.reset();
            this.StateService.selectedTester = tester;
            this.$location.path(`TraceSummary/${tester.Id}`);
        };
        this.buildTraceSummaryPath = (testerId, simId, suiteId) => {
            // return suiteId
            //     ? ['TraceSummary/', testerId, '/', simId, '/', suiteId].join('')
            //     : ['TraceSummary/', testerId, '/', simId].join('');
            return suiteId
                ? `TraceSummary/${testerId}/${simId}/${suiteId}`
                : `TraceSummary/${testerId}/${simId}`;
        };
        this.simTraceSummary = () => {
            const loggedInUserId = this.state.userDetails.Id;
            const testerId = this.routeParams.testerId || loggedInUserId;
            if (this.state.selectedSim === null) {
                return;
            }
            this.StateService.reset();
            this.StateService.selectedTester = this.state.selectedTester;
            this.StateService.selectedSim = this.state.selectedSim;
            const url = this.buildTraceSummaryPath(testerId, this.state.selectedSim.Id, null);
            this.$location.path(url);
        };
        this.suiteTraceSummary = () => {
            const loggedInUserId = this.state.userDetails.Id;
            const testerId = this.routeParams.testerId || loggedInUserId;
            if (this.state.selectedSim === null ||
                this.state.selectedSuite === null) {
                return;
            }
            const url = this.buildTraceSummaryPath(testerId, this.state.selectedSim.Id, this.state.selectedSuite.Id);
            this.StateService.reset();
            this.StateService.selectedTester = this.state.selectedTester;
            this.StateService.selectedSim = this.state.selectedSim;
            this.StateService.selectedSuite = this.state.selectedSuite;
            this.$location.path(url);
        };
        this.viewTest = (test) => {
            const mode = { view: true, run: false };
            this.openDetails(test, mode);
        };
        this.runTest = (test) => {
            // Set up our progress and disable the run button
            this.progressBar = this.ngProgressFactory.createInstance();
            this.progressBar.start();
            this.state.runDisabled = true;
            const data = {
                UserId: this.state.selectedTester.Id,
                SimId: this.state.selectedSim.Id,
                SuiteId: this.state.selectedSuite.Id,
                TestId: test.Id
            };
            this.UtpTestRunnerServiceApi.runTest(data).then((response) => {
                // Unwind the progress and disabled button
                this.progressBar.complete();
                this.state.runDisabled = false;
                if (angular.isUndefined(response)) {
                    this.toastr.warning('Warning: unable to contact the simulator');
                    return;
                }
                let result = response.data;
                if (result.errors.length > 0) {
                    for (let error of result.errors) {
                        this.toastr.error(error);
                    }
                }
            });
            const mode = { view: false, run: true };
            this.openDetails(test, mode);
            this.state.runDisabled = false;
            this.state.selectedTest = test;
        };
        this.deleteSuiteTests = () => {
            const userId = this.state.selectedTester.Id;
            const simId = this.state.selectedSim.Id;
            const suiteId = this.state.selectedSuite.Id;
            this.ResetService
                .resetTestExecutionTraces(userId, simId, suiteId, () => {
                this.selectSuite(this.state.selectedSuite);
            });
        };
        this.deleteTestCaseVerdicts = () => {
            const userId = this.state.selectedTester.Id;
            const simId = this.state.selectedSim.Id;
            const suiteId = this.state.selectedSuite.Id;
            this.ResetService
                .resetTestCaseVerdicts(userId, simId, suiteId, () => {
                this.getUserModel(userId, simId, suiteId);
            });
        };
        this.openDetails = (test, mode) => {
            // TODO: Confirm that this is the correct user
            let connectedUser;
            this.UserDetailsApi.get().then((response) => {
                connectedUser = response.data;
            })
                .then(() => {
                const selectedItems = {
                    selectedTester: this.state.selectedTester,
                    selectedSim: this.state.selectedSim,
                    selectedSuite: this.state.selectedSuite,
                    selectedTest: test,
                    projectIterationId: 0,
                    selectedTraceId: -1
                };
                const tdParams = {
                    user: connectedUser,
                    selectedItems: selectedItems,
                    mode: mode,
                    overTheShoulder: this.state.overTheShoulder
                };
                // Store our selected test
                this.state.selectedTest = test;
                this.StoredItemsService.storeTest({
                    Id: test.Id,
                    Name: test.Name
                });
                const modalInstance = this.uibModal
                    .open({
                    animation: true,
                    size: 'xl',
                    backdrop: 'static',
                    component: 'traceDetailsModal',
                    resolve: {
                        params: () => {
                            return tdParams;
                        }
                    }
                })
                    .result.then(() => {
                    // We only ever dismiss trace-details-modal
                    this.updateTestResults();
                }, 
                // dismiss callback
                () => {
                    this.updateTestResults();
                    // Restore selected test from trace-details-modal
                    this.StoredItemsService.load().then((storedItems) => {
                        this.state.selectedTest = storedItems.test;
                    });
                });
            });
        };
        // Hook method to catch file upload browser dialog
        // TODO: Find out if vm.state.errorMsg and vm.state.showError are used in the vm
        this.reportUpdate = (files) => {
            // reset error message
            this.state.showError = false;
            this.state.errorMsg = '';
            // Ensure there is one file selected
            if (files != null) {
                const fac = this.checkFileSizes(files);
                this.uploadFiles(fac.validFiles);
            }
            else {
                this.toastr.error('Could not determine file uploaded!\nPlease select a file and try again!');
            }
        };
        // Upload file method to process file and send to WebApi
        this.uploadFiles = (files) => {
            if (angular.isUndefined(files)) {
                return;
            }
            // Test length should be 1
            if (files.length !== null && files.length === 1) {
                const requestDto = {
                    // Get first file as only allowing one upload at a time
                    Files: files[0]
                };
                if (this.checkFileExtension(files[0])) {
                    // Upload file to the WebApi
                    this.uploadFileToWebApi(requestDto, this.state.selectedSuite.Id, this.state.selectedTester.Id, this.state.selectedSim.Id);
                }
                else {
                    this.state.showError = true;
                    this.state.errorMsg =
                        "Please select files with extension 'zip' or 'tpp' only!";
                    this.toastr.error(this.state.errorMsg);
                }
                files = null;
            }
        };
        // Upload File to the Web Api method
        this.uploadFileToWebApi = (requestDto, testSuiteId, userId, simId) => {
            const url = `api/TerminalReports/CollisTerminalReportUpload?userId=${userId}&simId=${simId}&testSuiteId=${testSuiteId}`;
            // Upload file to the WebApi
            this.Upload.upload({
                method: 'post',
                url: url,
                data: requestDto,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
                }
            }).then((response) => {
                if (response.data !== null && response.data === true) {
                    // OK
                    this.updateTestResults();
                    this.toastr.info('File uploaded successfully');
                }
                else {
                    this.state.errorMsg =
                        'Error occurred uploading Terminal report.\nYou may have selected incorrect file or format.\nPlease try again.';
                    this.toastr.error(this.state.errorMsg);
                }
                this.timeout(() => {
                    this.state.uploadProgress = -1;
                });
            }, (response) => {
                const errorMsg = response.data.ExceptionMessage;
                this.toastr.info(errorMsg);
            }, (evt) => {
                const progress = Math.min(100, Math.round(100.0 * evt.loaded / evt.total));
                this.state.uploadProgress = progress;
            });
        };
        // Test File size to ensure we do not allow users to upload files too big
        this.checkFileSizes = (files) => {
            const fac = {
                tooLarge: [],
                validFiles: []
            };
            angular.forEach(files, (file) => {
                if (file.size <= this.state.maxUploadMb * 1024 * 1024) {
                    fac.validFiles.push(file);
                }
                else {
                    fac.tooLarge.push(file);
                    const errorMsg = `File is too large. Please select a file less than ${this.state.maxUploadMb} MB`;
                    this.toastr.info(errorMsg);
                }
            });
            return fac;
        };
        // checkFileExtension is a valid extension
        this.checkFileExtension = (file) => {
            const extensions = 'zip,tpp';
            if (extensions.indexOf(file.name
                .split('.')
                .pop()
                .toLowerCase()) > -1) {
                return true;
            }
            else {
                return false;
            }
        };
        this.editSimulationData = (sim) => {
            this.UserDetailsApi.get().then((response) => {
                let connectedUser = response.data;
                let testerUserId = connectedUser.IsTester
                    ? connectedUser.Id
                    : this.state.selectedTester.Id;
                let modalInstance = this.uibModal.open({
                    animation: true,
                    backdrop: 'static',
                    component: 'editSimulationDataInstancesModal',
                    size: 'lg',
                    resolve: {
                        testerId: () => {
                            return testerUserId;
                        },
                        simId: () => {
                            return sim.Id;
                        }
                    }
                });
                modalInstance.result.then((modalResult) => {
                    return;
                }, 
                // dismiss callback
                (modalResult) => {
                    // reload the test suite to push any sim data updates to the sim in the /user/testplan API call
                    this.selectSuite(this.state.selectedSuite);
                });
            });
        };
        this.openProjectTesting = (sim) => {
            let route = `/TestExecution/${this.state.selectedTester.Id}/${sim.Id}`;
            this.$location.path(route);
        };
        this.shouldHaveProjectTestingEnabled = (sim) => {
            if (!this.state.projectTestingEnabled || !sim.RequiresProjectTesting) {
                return false;
            }
            return this.data.UserSimProjects.some(p => p.SimulatorId === sim.Id && p.UserId === this.state.selectedTester.Id);
        };
        this.selectAllCases = (checked) => {
            for (let testCase of this.data.TestCaseResults) {
                if (!this.isCaseDisabled(testCase)) {
                    this.setCaseChecked(testCase, checked);
                }
            }
        };
        this.onCaseCheckboxClick = (testCase, $event) => {
            // Stop the propagation to make sure we don't expand the folder or open the test case
            $event.stopPropagation();
            if (this.isCaseDisabled(testCase)) {
                return;
            }
            this.setCaseChecked(testCase, !this.isCaseChecked(testCase));
        };
        this.setCaseChecked = (testCase, checked) => {
            if (checked) {
                if (!this.isCaseChecked(testCase)) {
                    this.state.multiTestSelectedCases.push(testCase);
                }
            }
            else {
                _.remove(this.state.multiTestSelectedCases, (loopCase) => {
                    return loopCase.Id === testCase.Id;
                });
            }
        };
        this.isCaseChecked = (testCase) => {
            let val = _.some(this.state.multiTestSelectedCases, x => x.Id === testCase.Id);
            return val;
        };
        this.startTestRun = () => {
            this.traceProgress.start();
            this.state.multiTestIsLoading = true;
            let runTestReq = {
                UserId: this.state.selectedTester.Id,
                SimId: this.state.selectedSim.Id,
                SuiteId: this.state.selectedSuite.Id,
                TestCaseIds: this.state.multiTestSelectedCases.map(({ Id }) => Id)
            };
            this.resetProgress();
            this.multiTestProgress.TotalTestCount = runTestReq.TestCaseIds.length;
            this.multiTestProgress.InconclusiveTestCount = runTestReq.TestCaseIds.length;
            this.UtpTestRunnerServiceApi.runMultipleTests(runTestReq).then((response) => {
                let runId = response.data;
                this.state.multiTestIsLoading = false;
                this.traceProgress.complete();
                if (runId <= 0) {
                    this.toastr.error('Cannot start test(s). Please contact your administrator if this problem persists');
                    this.state.multiTestIsRunning = false;
                    this.resetProgress();
                }
                else {
                    // Change test case status to queued as default
                    this.state.multiTestSentCases = this.state.multiTestSelectedCases;
                    this.state.multiTestSentCases.forEach((tc) => {
                        tc.Status = 'Queued';
                    });
                    this.multiTestProgress.TestRunId = runId;
                    this.state.multiTestIsRunning = true;
                }
            });
        };
        this.notifyMultiTest = () => {
            /* Emit global event */
            let e = {
                simId: this.state.selectedSim.Id,
                testerId: this.state.selectedTester.Id,
                suiteId: this.state.selectedSuite.Id,
                multiTestIsRunning: this.state.multiTestIsRunning
            };
            this.multiTestNotificationService.changeAllOnMultiTestRun(e);
        };
        this.stopTestRun = () => {
            let modalOptions = {
                backdrop: 'static',
                actionButtonText: 'Cancel Test Run',
                closeButtonText: 'Do not cancel Test Run',
                headerText: 'Cancel Test Run',
                bodyText: 'Testing is currently in progress. Are you sure you want to cancel the test run?'
            };
            this.ModalService.showModal({}, modalOptions).then(() => {
                this.traceProgress.start();
                this.state.multiTestIsLoading = true;
                let cancelRequest = {
                    UserId: this.state.selectedTester.Id,
                    SimId: this.state.selectedSim.Id,
                    SuiteId: this.state.selectedSuite.Id
                };
                this.UtpTestRunnerServiceApi.cancelMultipleTests(cancelRequest).then((response) => {
                    let result = response.data;
                    this.state.multiTestIsLoading = false;
                    this.traceProgress.complete();
                    if (result.errors.length > 0) {
                        for (let error of result.errors) {
                            this.toastr.error(error);
                        }
                    }
                    else {
                        this.state.multiTestIsRunning = false;
                    }
                    this.notifyMultiTest();
                });
            });
        };
        this.resetProgress = () => {
            this.multiTestProgress.TestRunId = 0;
            this.multiTestProgress.TotalTestCount = 0;
            this.multiTestProgress.PassedTestCount = 0;
            this.multiTestProgress.FailedTestCount = 0;
            this.multiTestProgress.InconclusiveTestCount = 0;
        };
        this.getTestCaseCheckboxClass = (testCase) => {
            let checkboxIcon = '';
            if (this.isCaseChecked(testCase)) {
                checkboxIcon = 'fa-check';
            }
            // Change the colour a bit so the user can tell the checkbox is disabled
            if (this.isCaseDisabled(testCase)) {
                checkboxIcon += ' text-muted';
            }
            return checkboxIcon;
        };
        this.isCaseDisabled = (testCase) => {
            return this.state.runDisabled || this.state.multiTestIsRunning || this.state.multiTestIsLoading || !testCase.SupportsMultitest || !this.state.multiTestTestSuiteEnabled;
        };
        this.SettingsService = SettingsService;
        this.UserDetailsApi = UserDetailsApi;
        this.routeParams = $routeParams;
        this.UserTestSuiteService = UtpUserTestSuitesServiceApi;
        this.StoredItemsService = StoredItemsService;
        this.toastr = toastr;
        this.window = window;
        this.browser = $browser;
        this.moment = moment;
        this.$location = $location;
        this.timeout = $timeout;
        this.TesterSimSuitesServiceApi = TesterSimSuitesServiceApi;
        this.UtpTestRunnerServiceApi = UtpTestRunnerServiceApi;
        this.StateService = StateService;
        this.ngProgressFactory = ngProgressFactory;
        this.ModalService = ModalService;
        this.ResetService = ResetService;
        this.uibModal = $uibModal;
        this.Upload = Upload;
        this.TraceHubExService = TraceHubExService;
        this.multiTestNotificationService = multiTestNotificationService;
        this.ProjectTestingServiceApi = ProjectTestingServiceApi;
    }
}
angular.module('app').component('testerHome', {
    bindings: {},
    templateUrl: 'scripts/app/partials/Tester/Tester.tpl.html',
    controllerAs: 'vm',
    controller: TesterHomeController
});
